module.exports = __webpack_public_path__ + "img/resultado.70ebce07.jpg";